import axios from 'axios';
import { handleResponse, handleError } from '../../utils/axios';
import CONSTANTS from './constants/constants';

let CancelToken = axios.CancelToken;
let cancel;

const normalizeFilters = filters => {
    if (filters) {
        let normalized = {};
        filters.map(filter => {
            const { parameter } = filter;
            normalized = {
                ...normalized,
                [parameter]: {
                    ...filter
                }
            };
        });
        return normalized;
    }
};

const activeFilters = filters => {
    if (filters) {
        let normalized = [];
        filters.map(filter => {
            const { selectedValue } = filter;
            if (CONSTANTS.ACTIVE_FILTER_STATES.includes(selectedValue)) {
                normalized.push(filter);
            }
        });
        return normalized;
    }
};

const normalizeBrands = multiFilters => {
    if (multiFilters) {
        let normalized = {};
        multiFilters.map(filter => {
            if (filter.parameter === 'brandTags') {
                normalized = {
                    ...filter
                };
            }
        });
        return normalized;
    }
};

export const normalize = responseData => {
    const normalized = {
        pagination: responseData.pagination || null,
        itemsById: [],
        filterCategories: {},
        filters: {},
        filterBrands: {},
        filterPrice: {},
        activeFilters: [],
        activeBrands: [],
        totalItems: responseData.totalItems || 0,
        introText: responseData.introText || null,
        mainText: responseData.mainText || null,
    };
    if (responseData.filters) {
        normalized.filterCategories = responseData.filters.categoryFilter;
        normalized.filters = normalizeFilters(
            responseData.filters.singleOptionFilters
        );
        normalized.activeFilters = activeFilters(
            responseData.filters.singleOptionFilters
        );
        normalized.filterBrands = normalizeBrands(
            responseData.filters.multipleOptionsFilters
        );
        normalized.filterPrice = responseData.filters.priceRangeFilter;
    }

    if (responseData.items) {
        responseData.items.map(item => {
            normalized.itemsById.push(item.itemId);
        });
    }
    normalized.status = responseData.status;
    return normalized;
};
/**
 *
 * @param {*} searchParams
 * @param {string} baseUrl
 */
export const getSearchResults = async (
    endpoint,
    queryParams,
    baseURL = '',
    version
) => {
    if (!queryParams) {
        if (process && process.env && process.env.NODE_ENV !== 'production') {
            console.error(
                'getSearchResults must have queryParams as the first argument'
            );
        }

        return;
    }
    if (cancel !== undefined) {
        cancel();
    }

    try {
        let response = await axios.get(`${endpoint}.json`, {
            cancelToken: new CancelToken(function executor(c) {
                cancel = c;
            }),
            baseURL,
            params: queryParams
        });
        return handleResponse(response, version);
    } catch (e) {
        return handleError(e);
    }
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-results/helper.js